import React from "react";


import Typography from "@mui/joy/Typography";
import {Stack} from "@mui/joy";
import Button from "@mui/joy/Button";

// components
import withNavigate from "../../utils/withNavigate";
import BaseApi from "../../utils/BaseApi";


class MaterialHeader extends React.Component {
    async pdf(){
        const url = `material/${this.props.material.id}/garant_pdf/`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        this.props.navigate('/material/detail/' + response.data)
    }

    render() {
        return(
            <Stack>
                <Typography level={'h4'}>
                    {this.props.material.title}
                </Typography>
                <Stack>
                {
                    this.props.material.xtype === 'GARANT' && this.props.material.xformat === 'HTML' ?
                        <Button
                            color={'success'}
                            size={'sm'}
                            onClick={this.pdf.bind(this)}
                        >
                            PDF
                        </Button>:
                        null
                }
                </Stack>
            </Stack>
        )
    }
}

export default withNavigate(MaterialHeader)